module.exports = __webpack_public_path__ + "static/media/instructions-left.861b400b.png";